import React from 'react'
import { withRouter } from 'react-router-dom';
import withAuthentication from './identity/withAuthentication';

import {Row, Col, Input, Icon} from 'react-materialize'

import * as routes from '../config/routes';
import * as api from '../api'

import * as intakeCopy from '../assets/copy/intake'
import * as generalCopy from '../assets/copy/general'


class IntakeForm extends React.Component {
  state = {
    form: {},
    step: 1
  }

  constructor (props) {
    super(props)
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    e.preventDefault()
    var formBody = this.state.form
    api.makeApiPost(routes.INTAKE_FORM, formBody, (res, status) => {
        if (res.err || status !== 200) {
          this.setState({step: 8})
        } else {
          this.setState({form: {}})
          this.setState({step:7})
        }
    })
  }

  checkboxHelper(event) {
    var el
    if (event)
      el = event.target
    if (el) 
      this.state.form[el.value]= el.checked
  }

  valueHelper(event) {
    var el
    if (event)
      el = event.target
    if (el) {
      if (!(el.value === "")) {
        this.state.form[el.id]= el.value
      }
    }
  }

  render() {
    return (
      <div class="full-height valign-wrapper">
        <div className="container ">
          <div className="section">
            { (this.state.step === 1) ? (
              <div className="card-panel">
                <br/>
                <h5 className=" secondary-color-1-text question-title">
                  {intakeCopy.idea}
                </h5>
                <hr className="center-align secondary-color-2 secondary-color-2-text"/>

                <h5 className="mid-size-h">
                  {intakeCopy.noNeed}
                </h5>
                <h5 className="mid-size-h">
                  {intakeCopy.withUs}
                </h5>
                <br/>
                <Row>
                  <Col s={12} m={6} >
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Work with experts.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Count on a team.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Get quality code.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Build under budget.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Focus more on customers.</h6>
                  </Col>
                  <Col s={12} m={6}>

                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Don't give up your equity.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Don't sacrifice on your vision.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Avoid co-founder drama.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Scale up on your own time.</h6>
                    <h6>
                    <Icon tiny className="light-green-text accent-2">check</Icon> &nbsp; &nbsp;Focus less on recruiting.</h6>
                  </Col>
                </Row>
                <Row>
                  <p className="center-align">
                    <a className="btn" onClick={() => {this.setState({step: 2})}}>Let's do it!</a>
                  </p>
                </Row>
              </div>
            ) : false 
          }

          { (this.state.step === 2) ? (
          <div className="card-panel">
          <div className="s12 m12">
          <br/>
          <h5 className=" secondary-color-1-text question-title">
          Can we get it built?
          </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <Row>
          <Col s={12} l={4}>
          <table>
          <thead>
          <tr>
          <th>
          <h6 className="bold">If you need a:</h6>
          </th>
          </tr>
          </thead>
          <tbody>
          <tr>
          <td>Web Application</td>
          </tr>
          <tr>
          <td>Mobile Application</td>
          </tr>
          <tr>
          <td>Website</td>
          </tr>
          <tr>
          <td>Frontend Prototype</td>
          </tr>
          <tr>
          <td>Backend Service</td>
          </tr>
          </tbody>
          </table>
          </Col>

          <Col s={12} l={4}>
          <table>
          <thead>
          <tr>
          <th>
          <h6 className="bold">Built using:</h6>
          </th>
          </tr>
          </thead>
          <tbody>
          <tr>
          <td>JavaScript (Node/React)</td>
          </tr>
          <tr>
          <td>React Native (iOS/Android)</td>
          </tr>
          <tr>
          <td>Python</td>
          </tr>
          <tr>
          <td>Swift (iOS)</td>
          </tr>
          <tr>
          <td>Vanilla HTML/CSS</td>
          </tr>
          </tbody>
          </table>
          </Col>

          <Col s={12} l={4}>
          <table>
          <thead>
          <tr>
          <th>
          <h6 className="bold">That isn&#39;t:</h6>
          </th>
          </tr>
          </thead>
          <tbody>
          <tr>
          <td>Games</td>
          </tr>
          <tr>
          <td>Internet of Things</td>
          </tr>
          <tr>
          <td>Blockchain</td>
          </tr>
          <tr>
          <td>Virtual Reality</td>
          </tr>
          <tr>
          <td>Augmented Reality</td>
          </tr>
          </tbody>
          </table>
          </Col>
          </Row>
          <br/>

          <Row>
          <p className="center-align">
          <a className="btn" onClick={() => {this.setState({step: 3})}}>Absolutely!</a>
          </p>
          </Row>
          </div>
          </div>
          ) : false }

          { (this.state.step === 3) ? (
          <div className="card-panel">
          <Row>
          <Col s={12} m={6} >
          <br/>
          <h5 className=" secondary-color-1-text question-title">
          What do you have?
          </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['idea']} type="checkbox" className="filled-in" value="idea"/>
          <span className="dark-color-2-text"> I have an idea. </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['wireframes']} type="checkbox" className="filled-in" value="wireframes"/>
          <span className="dark-color-2-text"> I have wireframes. </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['spec']} type="checkbox" className="filled-in" value="spec"/>
          <span className="dark-color-2-text"> I have technical specifications. </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['budget']} type="checkbox" className="filled-in" value="budget"/>
          <span className="dark-color-2-text"> I have a budget. </span>
          </label>
          </p>
          </Col>
          <Col s={12} m={6}>

          <br/>
          <h5 className=" secondary-color-1-text question-title"> What do you need? </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['site']} type="checkbox" className="filled-in" value="site"/>
          <span className="dark-color-2-text"> Website or Landing Page</span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['webapp']} type="checkbox" className="filled-in" value="webapp"/>
          <span className="dark-color-2-text"> Web Application </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['mobile']} type="checkbox" className="filled-in" value="mobile"/>
          <span className="dark-color-2-text"> Mobile App</span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['other']} type="checkbox" className="filled-in" value="other"/>
          <span className="dark-color-2-text"> Something else. </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['unsure']} type="checkbox" className="filled-in" value="unsure"/>
          <span className="dark-color-2-text"> I'm not sure. </span>
          </label>
          </p>
          </Col>
          </Row>
          <Row>
          <p className="center-align">
          <a className="btn" onClick={() => {this.setState({step: 2})}}>Back</a> &nbsp; &nbsp; <a className="btn" onClick={() => {this.setState({step: 4})}}>Next</a>
          </p>
          </Row>
          </div>) : false }

          { (this.state.step === 4) ? (
          <div className="card-panel">
          <br/>
          <h5 className=" secondary-color-1-text question-title"> Who are your customers? </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>
          <Row>
          <Col s={12}>
          <h6 className="bold">How many users does your product need to serve? </h6>

          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['unsure']} type="checkbox" className="filled-in" value="unsure"/>
          <span className="dark-color-2-text"> I'm not sure.
          </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['1']} type="checkbox" className="filled-in" value="1"/>
          <span className="dark-color-2-text"> 1 - This is an internal tool.
          </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['2']} type="checkbox" className="filled-in" value="2"/>
          <span className="dark-color-2-text"> 2 - All of our users will have the same experience. Our team will need admin priviledges.
          </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['3']} type="checkbox" className="filled-in" value="3"/>
          <span className="dark-color-2-text"> 3 - Our users will be divided into two main roles. Ex. studenst, teacher or buyers, sellers. 
          </span>
          </label>
          </p>
          <p>
          <label>
          <input onChange={el => this.checkboxHelper(el)} defaultChecked={this.state.form['plus']} type="checkbox" className="filled-in" value="plus"/>
          <span className="dark-color-2-text"> 4+ - Our system need to customize the experience for many user roles.
          </span>
          </label>
          </p>
          </Col>
          </Row>
          <Col s={12} className="input-field">
          <textarea height={3} id="usertypes" className="materialize-textarea" onChange={el => this.valueHelper(el)} defaultValue={this.state.form['usertypes']}>
          </textarea>
          {!this.state.form['usertypes'] ? (<label for ="usertypes">What are your user types? </label>): false}

          </Col> 
          <Col s={12} className="input-field">
          <textarea height={3} id="purpose" className="materialize-textarea" onChange={el => this.valueHelper(el)} defaultValue={this.state.form['purpose']}>
          </textarea>
          {!this.state.form['purpose'] ? (<label for ="purpose">How will your product help them? </label>): false}
          </Col>
          <Row>
          <p className="center-align">
          <a className="btn" onClick={() => {this.setState({step: 3})}}>Back</a> &nbsp; &nbsp; <a className="btn" onClick={() => {this.setState({step: 5})}}>Next</a>
          </p>
          </Row>
          </div>) : false }
          { (this.state.step === 5) ? (
          <div className="card-panel">


          <br/>
          <h5 className=" secondary-color-1-text question-title"> What are your priorities? </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>
          <br/>
          <Row>
          <Input id = 'prio1' s={12} m={4} type='select' label="Priority #1:" onChange={el => this.valueHelper(el)}>
          <option selected={this.state.form['prio1'] === 'budget'} value="budget">Launching under budget.</option>
          <option selected={this.state.form['prio1'] === 'features'} value="features">Getting all my features.</option>
          <option selected={this.state.form['prio1'] === 'timeline'} value="timeline">Sticking to my timeline.</option>
          </Input>
          <Input id = 'prio2' s={12}  m={4} type='select' label="Priority #2:" onChange={el => this.valueHelper(el)}>
          <option selected={this.state.form['prio2'] === 'timeline'} value="timeline">Sticking to my timeline.</option>
          <option selected={this.state.form['prio2'] === 'features'} value="features">Getting all my features.</option>
          <option selected={this.state.form['prio2'] === 'budget'} value="budget">Launching under budget.</option>
          </Input>
          <Input id = 'prio3' s={12}  m={4} type='select' label="Priority #3:" onChange={el => this.valueHelper(el)}>
          <option selected={this.state.form['prio3'] === 'features'} value="features">Getting all my features.</option>
          <option selected={this.state.form['prio3'] === 'budget'} value="budget">Launching under budget.</option>
          <option selected={this.state.form['prio3'] === 'timeline'} value="timeline">Sticking to my timeline.</option>
          </Input>  
          <Col s={12} className="input-field">
          <textarea height={3} id="priorities" className="materialize-textarea" onChange={el => this.valueHelper(el)} defaultValue={this.state.form['priorities']}>
          </textarea>
          {!this.state.form['priorities'] ? (<label for ="priorities">What does success look like? </label>): false}
          </Col> </Row>
          <Row>
          <p className="center-align">
          <a className="btn" onClick={() => {this.setState({step: 4})}}>Back</a> &nbsp; &nbsp; <a className="btn" onClick={() => {this.setState({step: 6})}}>Next</a>
          </p>
          </Row>
          </div>) : false }
          { (this.state.step === 6) ? (
          <div className="card-panel">
          <br/>
          <h5 className=" secondary-color-1-text question-title"> How can we reach you? </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>
          <form onSubmit={this.submitForm}> 
          <Input required id='email' type="email" label="Email" onChange={el => this.valueHelper(el)} defaultValue = {this.state.form['email']}/>
          <Input required defaultValue = {this.state.form['name']} id='name' type="text" label="Name" onChange={el => this.valueHelper(el)}/>
          <Input defaultValue = {this.state.form['company']} id='company' type="text" label="Company" onChange={el => this.valueHelper(el)}/>
          <Row>
          <p className="center-align">
          <a className="btn" onClick={() => {this.setState({step: 5})}}>Back</a> &nbsp; &nbsp; 
          <button id="submit" className="btn">Let's Get It Built!</button>
          </p>
          </Row>
          </form>
          </div>) : false }
          { (this.state.step === 7) ? (
          <div className="card-panel">
          <br/>
          <h5 className=" secondary-color-1-text question-title"> {generalCopy.thanks} </h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <Row>
          <p className="mid-size-h center-align">We will get back to you soon with details on how we can help.</p>
          </Row>
          </div>
          ) : false }
          { (this.state.step === 8) ? (
          <div className="card-panel">
          <br/>
          <h5 className=" secondary-color-1-text question-title"> {generalCopy.problem}</h5>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <Row>
          <p className="mid-size-h center-align">{generalCopy.problemDetail}</p>
          </Row>
          <Row>
          <p className="center-align">
          <a onClick={() => {this.setState({step:3})}} className="btn" >{generalCopy.tryAgain}</a>
          </p>
          </Row>
          </div>
          ) : false }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withAuthentication(IntakeForm));


// WEBPACK FOOTER //
// ./src/components/IntakeForm.js